/**仿真软件模块 */
import request from '../request/http';
/**获取仿真软件模块树 */
export function GetSoftwareModules(data){
    return request({
        url: '/sp/software/getSoftwareModules',
        method: 'post',
        data
    })
}
/**分页查询仿真软件 */
export function SoftwarePageList(data){
    return request({
        url: '/sp/software/pageList',
        method: 'post',
        data
    })
}
/**添加仿真软件 */
export function AddSoftware(data){
    return request({
        url: '/sp/software/addSoftware',
        method: 'post',
        data
    })
}
/**删除仿真软件 */
export function DelSoftware(data){
    return request({
        url: '/sp/software/delSoftware',
        method: 'post',
        data
    })
}
/**修改仿真软件 */
export function UpdateSoftware(data){
    return request({
        url: '/sp/software/updateSoftware',
        method: 'post',
        data
    })
}
/**查询虚仿软件详情(无token) */
export function QuerySoftwareDetail(data){
    return request({
        url: '/sp/software/querySoftwareDetail',
        method: 'post',
        data
    })
}
/**查询虚仿软件详情（有token） */
export function QueryCopySoftwareDetail(data){
    return request({
        url: '/sp/software/querySoftwareInfo',
        method: 'post',
        data
    })
}
/**分页查询我收藏仿真软件 */
export function PageQueryCollectList(data){
    return request({
        url: '/sp/software/pageQueryCollectList',
        method: 'post',
        data
    })
}
/**共享仿真软件 */
export function ShareResData(data){
    return request({
        url: '/sp/software/shareResData',
        method: 'post',
        data
    })
}
/**取消共享 */
export function CancelShareResData(data){
    return request({
        url: '/sp/software/cancelShareResData',
        method: 'post',
        data
    })
}
/**查询仿真软件实训数据统计 */
export function QuerySoftwareStatistics(data){
    return request({
        url: '/sp/software/querySoftwareStatistics',
        method: 'post',
        data
    })
}
/**分页查询仿真软件学习记录 */
export function PageQuerySoftwareLearningRecord(data){
    return request({
        url: '/sp/software/pageQuerySoftwareLearningRecord',
        method: 'post',
        data
    })
}
/**查询软件实训租户列表 */
export function QuerySoftwareTrainingTenantList(data){
    return request({
        url: '/sp/software/querySoftwareTrainingTenantList?softwareCode='+data,
        method: 'post',
        data
    })
}
/**分页查询仿真软件使用记录 */
export function PageQuerySoftwareUseRecord(data){
    return request({
        url: '/sp/software/pageQuerySoftwareUseRecord',
        method: 'post',
        data
    })
}
/**分页查询仿真软件实训详情 */
export function PageQuerySoftwareTrainingDetail(data){
    return request({
        url: '/sp/software/pageQuerySoftwareTrainingDetail',
        method: 'post',
        data
    })
}
/**仿真资源校验 */
export function CheckSoftware(data){
    return request({
        url: '/sp/software/checkSoftware',
        method: 'post',
        data,
    })
}